import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useConfigState} from "../../hooks";
import {useRecordEvent} from "aws-rum-react";
import React from "react";

interface NamespaceFilterProps {
    namespace: string;
    setNamespace: (value: string) => void;
    isLoading: boolean;
}

const NamespaceFilter: React.FC<NamespaceFilterProps> = ({
                                                             namespace,
                                                             setNamespace,
                                                             isLoading,
                                                         }) => {
    const {t} = useTranslation();
    const {showDeepSearchHint} = useConfigState();
    const recordEvent = useRecordEvent();

    const nameSpaces: Record<string, string> = {
        "All": "oemAndSingle",
        "Single": "onlySingle",
        "OEM": "onlyOEM",
        "AimModel": "aimModel",
        "BtlAll": "btlAll",
        "BtlSingle": "btlSingle",
    };

    const changeForm = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedNamespace = event.target.id;

        switch (selectedNamespace) {
            case "All":
                recordEvent("SetAllImagesFilter", {description: "User selected all images in the filter possibility"});
                setNamespace(selectedNamespace);
                break;
            case "Single":
                recordEvent("SetSingleImagesFilter", {description: "User selected single images in the filter possibility"});
                setNamespace(selectedNamespace);
                break;
            case "OEM":
                recordEvent("SetPairsImagesFilter", {description: "User selected pair images in the filter possibility"});
                setNamespace(selectedNamespace);
                break;
            case "AimModel":
                if (!showDeepSearchHint) {
                    if (window.confirm(t("Filter.aimModelConfirmation"))) {
                        recordEvent("SetAimModelFilter", {
                            description: "User selected AimModel in the filter possibility and confirmed confirmation box",
                        });
                        setNamespace(selectedNamespace);
                    } else {
                        recordEvent("SetAimModelFilterButAborted", {
                            description: "User selected AimModel in the filter possibility, but aborted confirmation box",
                        });
                        return;
                    }
                } else {
                    recordEvent("SetAimModelFilter", {
                        description: "User selected AimModel in the filter possibility",
                    });
                    setNamespace(selectedNamespace);
                }
                break;
            case "BtlAll":
                recordEvent("SetAllImagesFilter", {description: "User selected BTL All images in the filter possibility"});
                setNamespace(selectedNamespace);
                break;
            case "BtlSingle":
                recordEvent("SetSingleImagesFilter", {description: "User selected BTL Single images in the filter possibility"});
                setNamespace(selectedNamespace);
                break;
        }
    };

    return (
        <Form className="d-flex flex-column gap-1">
            {Object.entries(nameSpaces).map(([key, value]) => (
                <Form.Check
                    key={key}
                    inline
                    label={t(`Filter.${value}`)}
                    name="namespace"
                    type="radio"
                    id={key}
                    disabled={isLoading}
                    checked={namespace === key}
                    onChange={changeForm}
                />
            ))}
        </Form>
    );
};

export default NamespaceFilter;
